export default __webpack_public_path__ + "static/media/36I-114291_-21030_0.20ab4d05.jpg";